











import { Component, Vue, Prop } from 'vue-property-decorator';

const visa = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/visa.svg';
const mastercard = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/mastercard.svg';
const amex = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/amex.svg';
const discover = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/discover.svg';
const jcb = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/jcb.svg';
const dinersclub = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/diners.svg';
const maestro = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/maestro.svg';
const unionpay = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/unionpay.svg';
const elo = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/elo.svg';
const hipercard = 'https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/svg/flat/hipercard.svg';
const dankort = 'https://quickpay.net/images/payment-methods/cards/dankort.svg';
const Eurocard = 'https://upload.wikimedia.org/wikipedia/commons/e/ec/Eurocard_Logo.svg';

@Component
export default class CardType extends Vue {
    @Prop() public type?: string;
    @Prop() public showError?: boolean;
    @Prop() public styles?: any;

    public animationTrigger: boolean = true;

    public icons: any = {
        visa,
        master: mastercard,
        amex,
        Discover: discover,
        jcb,
        maestro,
        union_pay: unionpay,
        elo,
        hiper: hipercard,
        diners: dinersclub,
        dan: dankort,
        Eurocard,
    };

    get iconSrc() {
        return this.icon && !this.showError
            ? this.icon
            : this.showError
                ? 'https://res.cloudinary.com/dbr1dziks/image/upload/v1553632916/cc_alert_wjbdhs.svg'
                : 'https://res.cloudinary.com/dbr1dziks/image/upload/v1553632916/cc_generic_dm8f0k.svg';
    }

    get animationClass() {
        return this.styles && this.styles.animation || '';
    }

    get iconClass() {
        return this.styles && this.styles.icon || '';
    }

    get icon() {
        this.animationTrigger = false;
        setTimeout(() => {
            this.animationTrigger = true;
        });
        if (this.type && this.icons[this.type]) {
            return this.icons[this.type];
        }
        return false;
    }
}
